import * as ApiManager from '../_manager';

export const adminRevenue = {
 
  markRevenuePaid: payload => {
    return ApiManager.callApi (
      `/admin/company/${payload.company_id}/revenue/markRevenuePaid`,
      payload
    );
  },
};
